import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberPrescriptionClaimsWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberPrescriptionClaimsWidgetService } from 'services/memberPrescriptionClaimsWidget';
 *
 * // create service instance and send/cancel request
 * const memberPrescriptionClaimsWidgetService = new MemberPrescriptionClaimsWidgetService();
 * const result = await memberPrescriptionClaimsWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberPrescriptionClaimsWidgetService.cancel(); // cancel an active request
 */
export class MemberPrescriptionClaimsWidgetService extends HttpService {

   // make request and fetch data
   async fetchComponentData( { url, data } ) {

    try {
        const response = await this.post( {
            host: CONFIG.host,
            path: url,
            data,
        } );
        
        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
            data: get( response, 'body.component', {} ),
        };
        
    } catch( errResponse ) {
        return this._errorFormatter( errResponse );
    }
}

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
